module.exports = __webpack_public_path__ + "assets/img/mecha-btn-416e53be.png";